export default [
    "16 16",
    '<path d="M9.25 6.75L13.625 2.375M13.625 2.375H9.875M13.625 2.375V6.125M6.75 9.25L2.375 13.625M2.375 13.625H6.125M2.375 13.625L2.375 9.875" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
]